import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-get-in-touch',
  templateUrl: './get-in-touch.component.html',
  styleUrls: ['./get-in-touch.component.scss'],
})
export class GetInTouchComponent implements OnInit {
  @Input() planDetails: string = '';
  @Output() onGetInTouchClick = new EventEmitter<any>();
  @Output() updateGetInTouchVariable = new EventEmitter<any>();
  formGroup: FormGroup;
  item: { lastName: string; email: string; businessName: string; phone_number: string };
  peoples = [
    { id: 1, name: 'General Inquiry' },
    { id: 2, name: 'Product Demo' },
    { id: 3, name: 'Pricing' },
    { id: 4, name: 'Technical Support' },
    { id: 5, name: 'Partnership' },
  ];
  peopleSelect: any;

  getphones = [
    { id: 1, name: '+62' },
    { id: 2, name: '+91' },
    { id: 3, name: '+1' },
    { id: 4, name: '+44' },
    { id: 5, name: '+86' },
  ];
  getphoneSelect: string = '+62';
  notesMaxLength: number = 500;
  notesCurrentLength: number = 0;

  constructor(private modalService: NgbModal, private fb: FormBuilder) {
    this.item = { lastName: '', email: '', businessName: '', phone_number: '' };
    this.initializeForm();
  }

  private initializeForm(): void {
    this.formGroup = this.fb.group({
      Topic: [null, Validators.required],
      Name: ['', [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern('^[a-zA-Z]+(\\s[a-zA-Z]+)*$')
      ]],
      Email: ['', [
        Validators.required,
        Validators.email,
        Validators.maxLength(50)
      ]],
      Phone: ['', [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
        Validators.minLength(8),
        Validators.maxLength(15)
      ]],
      'Business Name': ['', [
        Validators.required,
        Validators.maxLength(100)
      ]],
      Notes: ['', [
        Validators.required,
        Validators.maxLength(500)
      ]]
    });

    // Subscribe to notes changes to update character count
    this.formGroup.get('Notes')?.valueChanges.subscribe(value => {
      this.notesCurrentLength = value ? value.length : 0;
    });
  }

  ngOnInit() {
    if (this.planDetails) {
      this.formGroup.patchValue({
        Topic: this.planDetails
      });
    }
    this.onSignUpClick();
  }

  openModal(content: any) {
    this.modalService.open(content, {
      backdropClass: 'primary-backdrop',
      windowClass: 'project-modal custom-form-modal',
      centered: true,
      backdrop: false
    });
  }

  onTextValueChange(event: any): void {
    if (event.field) {
      const value = event.value?.value || event.value?.text || event.value;
      this.formGroup.patchValue({
        [event.field]: value
      });
    }
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.formGroup.get(fieldName);
    return field ? (field.invalid && (field.dirty || field.touched)) : false;
  }

  getErrorMessage(fieldName: string): string {
    const control = this.formGroup.get(fieldName);
    if (control && control.errors) {
      if (control.errors['required']) return 'This field is required';
      if (control.errors['email']) return 'Please enter a valid email address';
      if (control.errors['maxlength']) {
        if (fieldName === 'Name') return 'Name should not exceed 50 characters';
        if (fieldName === 'Business Name') return 'Business name should not exceed 100 characters';
        if (fieldName === 'Notes') return 'Notes should not exceed 500 characters';
        return `Maximum length exceeded`;
      }
      if (control.errors['pattern']) {
        if (fieldName === 'Phone') return 'Please enter valid phone number';
        if (fieldName === 'Name') return 'Please enter valid name';
      }
      if (control.errors['minlength']) return 'Phone number should be at least 8 digits';
    }
    return '';
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const formData = {
        ...this.formGroup.value,
        phoneCode: this.getphoneSelect,
        fullPhoneNumber: `${this.getphoneSelect}${this.formGroup.value.Phone}`
      };
      console.log('Form Submitted:', formData);
      this.modalService.dismissAll();
      this.formGroup.reset();
      this.getphoneSelect = '+62';
      this.notesCurrentLength = 0;
    } else {
      Object.keys(this.formGroup.controls).forEach(key => {
        const control = this.formGroup.get(key);
        if (control) {
          control.markAsTouched();
        }
      });
    }
  }

  onSignUpClick() {
    setTimeout(() => {
      const ele = document.getElementById('get-touch');
      if (ele) ele.click();
    }, 100);
    this.onGetInTouchClick.emit();
  }
  
  sendUpdate() {
    this.updateGetInTouchVariable.emit(false);
    this.modalService.dismissAll();
  }
}
